import React, { Component } from 'react';
import { WithStyles, withStyles } from '@mui/styles';

import APSelectItemStyles from './styles/APSelectItem.style';

interface APSelectItemProps extends WithStyles<typeof APSelectItemStyles> {
  displayName?: string,
  icon?: string,
  label: string,
  value: any
}

class APSelectItem extends Component<APSelectItemProps, {}> {
  _isMounted = false;
  state = {
    image: ''
  };

  componentDidMount() {
    this._isMounted = true;
    const {
      icon
    } = this.props;

    if (icon) {
      import(`./assets/${icon}.svg`).then(({ default: image }) => {
        this.setState({
          image
        });
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const {
      classes,
      displayName,
      label
    } = this.props;

    const renderedLabel = displayName ? displayName : label;

    return (
      <div className={classes.itemContainer} {...this.props}>
        {this.state.image && <img className={classes.itemIcon} src={this.state.image} alt="Flag icon" />}
        <span className={classes.itemLabel} data-testid="select-id" >{renderedLabel}</span>
      </div>
    );
  }
}

export default withStyles(APSelectItemStyles)(APSelectItem);
